var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Pane, PaneFooter, ErrorModal, ConfirmationModal, Headline, MessageBanner, Row, Col, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm, useFieldArray, FormProvider, } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { navigation } from "../../components/navigation";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { createTitleSchema } from "../../utils/validationUtils";
import { ErrorType } from "../../types/ErrorType";
import { resolveTitleSubjectErrorMessageIds } from "../../utils/titleSubjectErrors";
import { FormFooterStart } from "../../components/FormFooterStart";
import { FormFooterEnd } from "../../components/FormFooterEnd";
import { usePermissions } from "../../hooks/usePermissions";
import { usePublisherDataValidity } from "../../hooks/usePublisherDataValidity";
import { useOnixOptions } from "../../hooks/title/useOnixOptions";
import { useOwnerPublisherHydration } from "../../hooks/title/useOwnerPublisherHydration";
import { useOwnerPublisherPrefill } from "../../hooks/title/useOwnerPublisherPrefill";
import { useAgencyPublisherHandlers } from "../../hooks/title/useAgencyPublisherHandlers";
import { firstOnix } from "../../utils/selectMappers";
import { collectUniqueErrorMessages } from "../../utils/formErrorUtils";
import { useModal } from "../../utils/useModal";
import { getErrorCodes } from "../../utils/getErrorCode";
import { resolveTitleCreateErrorMessageId } from "../../utils/titleCreateErrors";
import { useTitleFormValues } from "../../utils/titleFormValues";
import TitleOwnerForm from "../../components/title/TitleOwnerForm";
import TitleNamesForm from "../../components/title/TitleNamesForm";
import TitleContributionsForm from "../../components/title/TitleContributionsForm";
import TitlePublishersForm from "../../components/title/TitlePublishersForm";
import TitlePublicationPlacesForm from "../../components/title/TitlePublicationPlacesForm";
import TitleLanguagesForm from "../../components/title/TitleLanguagesForm";
import TitleSubjectsForm from "../../components/title/TitleSubjectsForm";
import TitleTextContentsForm from "../../components/title/TitleTextContentsForm";
import TitleSupportingResourcesForm from "../../components/title/TitleSupportingResourcesForm";
import TitleAudiencesForm from "../../components/title/TitleAudiencesForm";
import TitleAdditionalInfoForm from "../../components/title/TitleAdditionalInfoForm";
import { TitleCollectionsForm } from "../../components/title/TitleCollectionsForm";
import { TitleImprintField } from "../../components/title/TitleImprintField";
import TitleFormTabs from "../../components/title/TitleFormTabs";
import { useScrollToError } from "../../hooks/useScrollToError";
import { useCollectionHandlers } from "../../hooks/title/useCollectionHandlers";
import styles from "./TitleForm.module.css";
/** Scalar-field sections and the fields they render, in display order. */
var SCALAR_SECTION_FIELDS = {
    editionInfo: [
        "editionNumber",
        "editionStatement",
        "illustrationsNote",
        "commentForAgency",
    ],
    ageRange: ["ageFrom", "ageTo"],
    doi: ["doi"],
};
/**
 * Single source of truth for the tab layout. Moving a section between tabs is a
 * one-line change here (adjust `sections` and, if the field is validated,
 * `errorFields`).
 */
var TITLE_FORM_TABS = [
    {
        id: "basic",
        labelId: "ui-br-agency.title.form.tab.basic",
        sections: ["names", "languages", "collections", "editionInfo"],
        errorFields: [
            "names",
            "languages",
            "titleCollections",
            "editionNumber",
            "editionStatement",
            "illustrationsNote",
            "commentForAgency",
        ],
    },
    {
        id: "creators",
        labelId: "ui-br-agency.title.form.tab.creators",
        sections: ["contributions"],
        errorFields: ["titleContributions"],
    },
    {
        id: "publisher",
        labelId: "ui-br-agency.title.form.tab.publisher",
        sections: ["owner", "publishers", "publicationPlaces", "imprint"],
        errorFields: ["owner", "titlePublishers", "publicationPlaces", "imprint"],
    },
    {
        id: "content",
        labelId: "ui-br-agency.title.form.tab.content",
        sections: ["subjects", "textContents", "audiences", "ageRange"],
        errorFields: ["subjects", "textContents", "audiences", "ageFrom", "ageTo"],
    },
    {
        id: "cover",
        labelId: "ui-br-agency.title.form.tab.cover",
        sections: ["supportingResources", "doi"],
        errorFields: ["supportingResources", "doi"],
    },
];
var DEFAULT_TAB = "basic";
/** Any error field not explicitly mapped falls back to the first (basic) tab. */
var FALLBACK_ERROR_TAB = "basic";
var FIELD_TO_TAB = TITLE_FORM_TABS.reduce(function (acc, tab) {
    tab.errorFields.forEach(function (field) {
        acc[field] = tab.id;
    });
    return acc;
}, {});
var resolveTabForField = function (field) { var _a; return (_a = FIELD_TO_TAB[field]) !== null && _a !== void 0 ? _a : FALLBACK_ERROR_TAB; };
var contributionErrorTypes = [
    ErrorType.TITLE_CONTRIBUTION_NAME_REQUIRED,
    ErrorType.TITLE_CONTRIBUTION_PERSON_XOR_UNNAMED,
];
/**
 * Backend rejections of supporting resources: image types 01–10 (issue
 * #75515) and the table of contents type 25 PDF link (issue #75957).
 */
var RESOURCE_IMAGE_ERROR_MESSAGE_IDS = (_a = {},
    _a[ErrorType.TITLE_SUPPORTING_RESOURCE_IMAGE_MODE_REQUIRED] = "ui-br-agency.title.error.resourceImageMode",
    _a[ErrorType.TITLE_SUPPORTING_RESOURCE_IMAGE_LINK_INVALID] = "ui-br-agency.title.error.resourceImageLink",
    _a[ErrorType.TITLE_SUPPORTING_RESOURCE_PDF_LINK_INVALID] = "ui-br-agency.title.error.resourcePdfLink",
    _a);
/**
 * Static, always-expanded form section — a heading followed by the section
 * content. Sections of the title form are intentionally not collapsible.
 */
var FormSection = function (_a) {
    var id = _a.id, label = _a.label, children = _a.children;
    return (React.createElement("section", { id: id, className: styles.formSection, "aria-label": label },
        React.createElement("div", { className: styles.formSectionHeading },
            React.createElement(Headline, { size: "large", margin: "none", tag: "h3" }, label)),
        children));
};
var TitleForm = function (_a) {
    var _b, _c, _d, _e, _f;
    var initialValues = _a.initialValues, onSubmit = _a.onSubmit, title = _a.title, detailPane = _a.detailPane;
    var formatMessage = useIntl().formatMessage;
    var history = useHistory();
    var location = useLocation();
    var _g = useModal(), isOpen = _g.isOpen, message = _g.message, openModal = _g.openModal, closeModal = _g.closeModal;
    var _h = useState(null), contributionServerError = _h[0], setContributionServerError = _h[1];
    var isOnlyPublisherGuarantor = usePermissions().isPublisherRoleOnly;
    var municipality = usePublisherDataValidity().municipality;
    var _j = useOnixOptions(), nameTypeTable = _j.nameTypeTable, languageRoleTable = _j.languageRoleTable, languageTable = _j.languageTable, textContentTypeTable = _j.textContentTypeTable, resourceTypeTable = _j.resourceTypeTable, resourceModeTable = _j.resourceModeTable, audienceTypeTable = _j.audienceTypeTable, subjectSchemeTable = _j.subjectSchemeTable, publisherRoleTable = _j.publisherRoleTable, publisherRoleLoading = _j.publisherRoleLoading, publisherRoleStatus = _j.publisherRoleStatus;
    var formValues = useTitleFormValues({
        initialValues: initialValues,
        nameTypeTbl: nameTypeTable,
        langRoleTbl: languageRoleTable,
        languageTbl: languageTable,
        textContentTypeTbl: textContentTypeTable,
        resourceTypeTbl: resourceTypeTable,
        resourceModeTbl: resourceModeTable,
        audienceTypeTbl: audienceTypeTable,
        subjectSchemeTbl: subjectSchemeTable,
        roleOnixTable: publisherRoleTable,
    });
    var methods = useForm({
        resolver: zodResolver(createTitleSchema(formatMessage)),
        values: formValues,
        mode: "onBlur",
        shouldUnregister: false,
    });
    var handleSubmit = methods.handleSubmit, control = methods.control, setValue = methods.setValue, trigger = methods.trigger, getValues = methods.getValues, reset = methods.reset, _k = methods.formState, errors = _k.errors, isDirty = _k.isDirty, isSubmitting = _k.isSubmitting;
    var _l = useState(null), pendingNavigation = _l[0], setPendingNavigation = _l[1];
    var _m = useState(false), showSavedBanner = _m[0], setShowSavedBanner = _m[1];
    // TitleCreate redirects here with ?saved=1 right after creating the title.
    // Show the banner and strip the param so a refresh doesn't re-show it.
    useEffect(function () {
        var params = new URLSearchParams(location.search);
        if (params.get("saved") === "1") {
            setShowSavedBanner(true);
            params.delete("saved");
            history.replace({
                pathname: location.pathname,
                search: params.toString(),
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useScrollToError(errors);
    // Active tab lives in the `?tab=` query param so it survives refresh and is
    // shareable. Falls back to the default tab for missing/unknown values.
    var tabParam = new URLSearchParams(location.search).get("tab");
    var activeTab = TITLE_FORM_TABS.some(function (tab) { return tab.id === tabParam; })
        ? tabParam
        : DEFAULT_TAB;
    var activeSections = (_c = (_b = TITLE_FORM_TABS.find(function (tab) { return tab.id === activeTab; })) === null || _b === void 0 ? void 0 : _b.sections) !== null && _c !== void 0 ? _c : [];
    var setActiveTab = function (tabId) {
        var params = new URLSearchParams(location.search);
        params.set("tab", tabId);
        // Use replace to avoid polluting the browser history on every tab switch.
        history.replace({ pathname: location.pathname, search: params.toString() });
    };
    var switchToFirstErrorTab = function (fields) {
        var errorTabs = new Set(fields.map(resolveTabForField));
        var firstTab = TITLE_FORM_TABS.find(function (tab) { return errorTabs.has(tab.id); });
        if (firstTab && firstTab.id !== activeTab) {
            setActiveTab(firstTab.id);
        }
    };
    var errorCounts = useMemo(function () {
        var counts = {
            basic: 0,
            creators: 0,
            publisher: 0,
            content: 0,
            cover: 0,
        };
        Object.keys(errors).forEach(function (field) {
            counts[resolveTabForField(field)] += 1;
        });
        return counts;
    }, [errors]);
    var tabs = TITLE_FORM_TABS.map(function (tab) { return ({
        id: tab.id,
        labelId: tab.labelId,
        errorCount: errorCounts[tab.id],
    }); });
    var _o = useOwnerPublisherHydration(initialValues, setValue), ownerOptions = _o.ownerOptions, setOwnerOptions = _o.setOwnerOptions, publisherOptions = _o.publisherOptions, setPublisherOptions = _o.setPublisherOptions;
    var _p = useFieldArray({ control: control, name: "titlePublishers" }), publisherFields = _p.fields, appendPublisher = _p.append, updatePublisher = _p.update, removePublisher = _p.remove;
    var isCreateMode = !initialValues.id;
    useOwnerPublisherPrefill({
        enabled: isOnlyPublisherGuarantor && isCreateMode,
        publisherRoleTable: publisherRoleTable,
        setValue: setValue,
        setOwnerOptions: setOwnerOptions,
        setPublisherOptions: setPublisherOptions,
        municipality: municipality,
    });
    var _q = useAgencyPublisherHandlers({
        setOwnerOptions: setOwnerOptions,
        setPublisherOptions: setPublisherOptions,
        setValue: setValue,
        trigger: trigger,
        getValues: getValues,
        isCreateMode: isCreateMode,
    }), handleAgencyPublisherChange = _q.handleAgencyPublisherChange, onEntityFilter = _q.onEntityFilter, prefillMunicipalityFromPublisher = _q.prefillMunicipalityFromPublisher;
    var _r = useCollectionHandlers({
        initialValues: initialValues,
        setValue: setValue,
    }), collectionOptions = _r.collectionOptions, addCollectionOption = _r.addCollectionOption, resetCollectionOptions = _r.resetCollectionOptions, onCollectionFilter = _r.onCollectionFilter;
    var requiredFieldChecks = [
        {
            field: "names",
            messageId: "ui-br-agency.title.validation.names.required",
            isMissing: function (data) { var _a; return !((_a = data.names) === null || _a === void 0 ? void 0 : _a.length); },
        },
        {
            field: "languages",
            messageId: "ui-br-agency.title.validation.languages.required",
            isMissing: function (data) { var _a; return !((_a = data.languages) === null || _a === void 0 ? void 0 : _a.length); },
        },
        {
            field: "publicationPlaces",
            messageId: "ui-br-agency.title.validation.places.required",
            isMissing: function (data) { var _a; return !((_a = data.publicationPlaces) === null || _a === void 0 ? void 0 : _a.length); },
        },
        {
            field: "owner",
            messageId: "ui-br-agency.title.validation.owner.required",
            isMissing: function (data) { return !data.owner; },
        },
    ];
    var handleFormSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var missing, error_1, errorCodes, errorCode, resourceImageMessageId, subjectMessageIds, msgId, key;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 4]);
                    setShowSavedBanner(false);
                    setContributionServerError(null);
                    missing = requiredFieldChecks.filter(function (check) {
                        return check.isMissing(data);
                    });
                    if (missing.length) {
                        openModal(missing
                            .map(function (check) { return formatMessage({ id: check.messageId }); })
                            .join("\n"));
                        switchToFirstErrorTab(missing.map(function (check) { return check.field; }));
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, onSubmit(data)];
                case 1:
                    _a.sent();
                    // Saved successfully — make the current values the new clean baseline so
                    // the form is no longer "dirty" (otherwise Close warns about unsaved
                    // changes even though everything was saved).
                    reset(data);
                    setShowSavedBanner(true);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    return [4 /*yield*/, getErrorCodes(error_1)];
                case 3:
                    errorCodes = _a.sent();
                    errorCode = errorCodes[0];
                    if (errorCode === ErrorType.MAIN_TITLE_EXACTLY_ONE) {
                        openModal(formatMessage({
                            id: "ui-br-agency.title.error.mainTitleExactlyOne",
                        }));
                        switchToFirstErrorTab(["names"]);
                        return [2 /*return*/];
                    }
                    resourceImageMessageId = errorCode
                        ? RESOURCE_IMAGE_ERROR_MESSAGE_IDS[errorCode]
                        : undefined;
                    if (resourceImageMessageId) {
                        openModal(formatMessage({ id: resourceImageMessageId }));
                        switchToFirstErrorTab(["supportingResources"]);
                        return [2 /*return*/];
                    }
                    subjectMessageIds = resolveTitleSubjectErrorMessageIds(errorCodes);
                    if (subjectMessageIds.length > 0) {
                        openModal(subjectMessageIds.map(function (id) { return (React.createElement("div", { key: id }, formatMessage({ id: id }))); }));
                        switchToFirstErrorTab(["subjects"]);
                        return [2 /*return*/];
                    }
                    if (errorCode && contributionErrorTypes.includes(errorCode)) {
                        msgId = errorCode === ErrorType.TITLE_CONTRIBUTION_NAME_REQUIRED
                            ? "ui-br-agency.title.error.contributionNameRequired"
                            : "ui-br-agency.title.error.contributionPersonXorUnnamed";
                        setContributionServerError(formatMessage({ id: msgId }));
                        switchToFirstErrorTab(["titleContributions"]);
                    }
                    key = initialValues.id
                        ? "ui-br-agency.title.error.update"
                        : resolveTitleCreateErrorMessageId(errorCode);
                    openModal(formatMessage({ id: key }));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleInvalidSubmit = function (formErrors) {
        var messages = collectUniqueErrorMessages(formErrors);
        openModal(__spreadArray([
            formatMessage({ id: "ui-br-agency.title.form.invalid" })
        ], messages, true).map(function (message) { return React.createElement("div", { key: message }, message); }));
        switchToFirstErrorTab(Object.keys(formErrors));
    };
    /**
     * Leaves the form: back to the title list with the edited title's detail
     * open, or to the plain list when a new title is being created.
     */
    var navigateOnClose = function () {
        if (!navigation.titles)
            return;
        history.push(initialValues.id
            ? "".concat(navigation.titles.path, "?detail=").concat(initialValues.id)
            : navigation.titles.path);
    };
    /** Close asks to discard unsaved changes first; a clean form closes at once. */
    var handleClose = function () {
        if (isDirty) {
            setPendingNavigation(function () { return navigateOnClose; });
        }
        else {
            navigateOnClose();
        }
    };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: title, footer: React.createElement(PaneFooter, { renderStart: React.createElement(FormFooterStart, { handleSubmit: handleSubmit, onSubmit: handleFormSubmit, onInvalid: handleInvalidSubmit, buttonMessageId: "ui-br-agency.button.save", submitting: isSubmitting }), renderEnd: React.createElement(FormFooterEnd, { onCancel: handleClose, buttonMessageId: "ui-br-agency.button.close" }) }) },
            React.createElement(ErrorModal, { open: isOpen, label: formatMessage({ id: "ui-br-agency.modal.label.error" }), content: message, onClose: closeModal }),
            React.createElement(ConfirmationModal, { open: pendingNavigation !== null, heading: formatMessage({
                    id: "ui-br-agency.title.form.cancel.heading",
                }), message: formatMessage({
                    id: "ui-br-agency.title.form.cancel.message",
                }), onConfirm: function () { return pendingNavigation === null || pendingNavigation === void 0 ? void 0 : pendingNavigation(); }, onCancel: function () { return setPendingNavigation(null); }, confirmLabel: formatMessage({
                    id: "ui-br-agency.title.form.cancel.confirm",
                }), cancelLabel: formatMessage({
                    id: "ui-br-agency.button.cancel",
                }), buttonStyle: "danger" }),
            React.createElement(TitleFormTabs, { tabs: tabs, activeTab: activeTab, onTabChange: setActiveTab }),
            showSavedBanner && (React.createElement(MessageBanner, { type: "success", dismissible: true, onExited: function () { return setShowSavedBanner(false); } },
                React.createElement(FormattedMessage, { id: "ui-br-agency.title.form.saved.banner" }))),
            React.createElement(FormProvider, __assign({}, methods),
                React.createElement("form", { noValidate: true, onSubmit: handleSubmit(function (data) {
                        handleFormSubmit(data);
                    }, handleInvalidSubmit) },
                    activeSections.includes("names") && (React.createElement(FormSection, { id: "names", label: formatMessage({
                            id: "ui-br-agency.title.form.section.names",
                        }) },
                        React.createElement(TitleNamesForm, null))),
                    activeSections.includes("languages") && (React.createElement(FormSection, { id: "languages", label: formatMessage({
                            id: "ui-br-agency.title.form.section.languages",
                        }) },
                        React.createElement(TitleLanguagesForm, null))),
                    activeSections.includes("collections") && (React.createElement(FormSection, { id: "collections", label: formatMessage({
                            id: "ui-br-agency.title.form.section.collections",
                        }) },
                        React.createElement(TitleCollectionsForm, { titleId: initialValues.id, collectionOptions: collectionOptions, addCollectionOption: addCollectionOption, resetCollectionOptions: resetCollectionOptions, onCollectionFilter: onCollectionFilter }))),
                    activeSections.includes("editionInfo") && (React.createElement(TitleAdditionalInfoForm, { fields: (_d = SCALAR_SECTION_FIELDS.editionInfo) !== null && _d !== void 0 ? _d : [] })),
                    activeSections.includes("contributions") && (React.createElement(FormSection, { id: "contributions", label: formatMessage({
                            id: "ui-br-agency.title.form.section.contributions",
                        }) },
                        React.createElement(TitleContributionsForm, { serverError: contributionServerError, onClearServerError: function () { return setContributionServerError(null); } }))),
                    activeSections.includes("owner") && (React.createElement(FormSection, { id: "owner", label: formatMessage({
                            id: "ui-br-agency.title.form.section.owner",
                        }) },
                        React.createElement(TitleOwnerForm, { ownerOptions: ownerOptions, onOwnerFilter: onEntityFilter("owner"), onOwnerChange: handleAgencyPublisherChange("owner"), disabled: isOnlyPublisherGuarantor }))),
                    activeSections.includes("publishers") && (React.createElement(FormSection, { id: "publishers", label: formatMessage({
                            id: "ui-br-agency.title.form.section.publishers",
                        }) },
                        React.createElement(TitlePublishersForm, { publisherFields: publisherFields, appendPublisher: function (value) {
                                var _a;
                                return appendPublisher({
                                    publisher: value.publisher,
                                    role: (_a = value.role) !== null && _a !== void 0 ? _a : firstOnix(publisherRoleTable),
                                });
                            }, updatePublisher: updatePublisher, removePublisher: removePublisher, isOnlyPublisherGuarantor: isOnlyPublisherGuarantor, publisherRoleItems: publisherRoleTable === null || publisherRoleTable === void 0 ? void 0 : publisherRoleTable.onixCodetableItems, publisherRoleLoading: publisherRoleLoading, publisherRoleStatus: publisherRoleStatus, publisherOptions: publisherOptions, onPublisherFilter: onEntityFilter("publisher"), prefillMunicipalityFromPublisher: prefillMunicipalityFromPublisher }))),
                    activeSections.includes("publicationPlaces") && (React.createElement(FormSection, { id: "publicationPlaces", label: formatMessage({
                            id: "ui-br-agency.title.form.section.publicationPlaces",
                        }) },
                        React.createElement(TitlePublicationPlacesForm, null))),
                    activeSections.includes("imprint") && (React.createElement(Row, null,
                        React.createElement(Col, { xs: 12 },
                            React.createElement(TitleImprintField, null)))),
                    activeSections.includes("subjects") && (React.createElement(FormSection, { id: "subjects", label: formatMessage({
                            id: "ui-br-agency.title.form.section.subjects",
                        }) },
                        React.createElement(TitleSubjectsForm, null))),
                    activeSections.includes("textContents") && (React.createElement(FormSection, { id: "textContents", label: formatMessage({
                            id: "ui-br-agency.title.form.section.textContents",
                        }) },
                        React.createElement(TitleTextContentsForm, null))),
                    activeSections.includes("audiences") && (React.createElement(FormSection, { id: "audiences", label: formatMessage({
                            id: "ui-br-agency.title.form.section.audiences",
                        }) },
                        React.createElement(TitleAudiencesForm, null))),
                    activeSections.includes("ageRange") && (React.createElement(TitleAdditionalInfoForm, { fields: (_e = SCALAR_SECTION_FIELDS.ageRange) !== null && _e !== void 0 ? _e : [] })),
                    activeSections.includes("supportingResources") && (React.createElement(FormSection, { id: "supportingResources", label: formatMessage({
                            id: "ui-br-agency.title.form.section.supportingResources",
                        }) },
                        React.createElement(TitleSupportingResourcesForm, null))),
                    activeSections.includes("doi") && (React.createElement(TitleAdditionalInfoForm, { fields: (_f = SCALAR_SECTION_FIELDS.doi) !== null && _f !== void 0 ? _f : [] }))))),
        detailPane));
};
export default TitleForm;
